import { useState, useEffect } from "react";
import { Button, Form, Table, Card, Alert } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate } from 'react-router-dom';

const emptyCliente = () => ({
  nome: "",
  telefone: "",
  valor_aberto: "",
  data_pagamento: "",
  primeira_compra: "",
  ultima_compra: "",
  aniversario: "",
});

const ImportarClientes = () => {
  const [clientes, setClientes] = useState([emptyCliente()]);
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const {
    crud,
    setTitle
  } = useProvider();
  const { post, loading } = crud || {}
  setTitle("Importar Clientes")

  const addLinha = () => setClientes([...clientes, emptyCliente()]);
  const removeLinha = (i) => { if (clientes.length === 1) return; setClientes(clientes.filter((_, idx) => idx !== i)); };
  const updateField = (i, field, value) => { const temp = [...clientes]; temp[i][field] = value; setClientes(temp); };
  const handleSubmit = async(e) => { 
    e.preventDefault(); 
    console.log({ clientes }); 
    setFormErrors({});
    const lista = clientes.map(c => ({
      ...c,
      data_pagamento: c.data_pagamento || null,
      primeira_compra: c.primeira_compra || null,
      ultima_compra: c.ultima_compra || null,
      aniversario: c.aniversario || null,
    }));
    try{
      const response = await post({
        clientes:lista
      }, `/gvendas/clientes/importar-clientes/`);
      if(response && response.length){
        navigate(-1);
      }
    } catch (error) {
      if (error.response) {
        if (error.response?.data?.clientes){
          setFormErrors(error.response.data.clientes);
        }else{
          setFormErrors({apiError:"Ocorreu um erro ao salvar"});
        }
      } else if (error.request) {
        // O request foi feito mas não houve resposta
        setFormErrors({apiError:"Sem resposta do servidor"});
      } else {
        // Outro tipo de erro
        setFormErrors({apiError:error.message || 'Erro ao configurar requisição'});
      }
    }
  };

  return (<>
    <Card className="p-3">
      <div className="mb-3 small text-muted">Importe seus clientes para base de dados do App</div>

      <Form onSubmit={handleSubmit}>
        {formErrors.apiError && <Alert variant="danger" size="sm">{formErrors.apiError}</Alert>}
        <div className="table-responsive">
          {/* note o tableLayout: 'fixed' */}
          <Table bordered hover size="sm" style={{ tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: "220px" }} /> {/* Nome */}
              <col style={{ width: "150px" }} /> {/* Telefone */}
              <col style={{ width: "120px" }} /> {/* Valor */}
              <col style={{ width: "130px" }} /> {/* Pagamento */}
              <col style={{ width: "130px" }} /> {/* Primeira compra */}
              <col style={{ width: "130px" }} /> {/* Última compra */}
              <col style={{ width: "130px" }} /> {/* Aniversário */}
              <col style={{ width: "60px" }} /> {/* Ações */}
            </colgroup>

            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>Valor Aberto</th>
                <th>Pagamento</th>
                <th>1ª Compra</th>
                <th>Última Compra</th>
                <th>Aniversário</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {clientes.map((c, i) => (
                <tr key={i}>
                  <td>
                    {/* garantir 100% para o input preencher a célula */}
                    <Form.Control value={c.nome} onChange={(e) => updateField(i, "nome", e.target.value)} style={{ width: "100%" }} />
                    {formErrors[i]?.nome && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.nome}</Alert>}
                  </td>

                  <td>
                    <InputMask mask="(99) 99999-9999" value={c.telefone} onChange={(e) => updateField(i, "telefone", e.target.value)}>
                      {(inputProps) => <Form.Control {...inputProps} style={{ width: "100%" }} />}
                    </InputMask>
                    {formErrors[i]?.telefone && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.telefone}</Alert>}
                  </td>

                  <td>
                    <Form.Control type="number" step="0.01" value={c.valor_aberto}
                      onChange={(e) => updateField(i, "valor_aberto", e.target.value)}
                      onBlur={(e) => updateField(i, "valor_aberto", parseFloat(e.target.value || 0).toFixed(2))}
                      style={{ width: "100%" }}
                    />
                    {formErrors[i]?.valor_aberto && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.valor_aberto}</Alert>}
                  </td>

                  <td>
                    <Form.Control type="date" value={c.data_pagamento} onChange={(e) => updateField(i, "data_pagamento", e.target.value)} style={{ width: "100%" }} />
                    {formErrors[i]?.data_pagamento && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.data_pagamento}</Alert>}
                  </td>

                  <td>
                    <Form.Control type="date" value={c.primeira_compra} onChange={(e) => updateField(i, "primeira_compra", e.target.value)} style={{ width: "100%" }} />
                    {formErrors[i]?.primeira_compra && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.primeira_compra}</Alert>}
                  </td>

                  <td>
                    <Form.Control type="date" value={c.ultima_compra} onChange={(e) => updateField(i, "ultima_compra", e.target.value)} style={{ width: "100%" }} />
                    {formErrors[i]?.ultima_compra && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.ultima_compra}</Alert>}
                  </td>

                  <td>
                    <Form.Control type="date" value={c.aniversario} onChange={(e) => updateField(i, "aniversario", e.target.value)} style={{ width: "100%" }} />
                    {formErrors[i]?.aniversario && <Alert variant="danger" className="small p-1 m-0">*{formErrors[i]?.aniversario}</Alert>}
                  </td>

                  <td className="text-center">
                    <Button variant="danger" size="sm" onClick={() => removeLinha(i)}><i className="bx bx-trash"></i></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="text-center">
          <Button variant="outline-dark" size="sm" onClick={addLinha}>Adicionar Linha</Button>
          <Button type="submit" className="ms-2" variant="outline-dark">Enviar</Button>
        </div>
      </Form>
    </Card>
  </>);
}

const ImportFile = () => {
  const [abas, setAbas] = useState({});
  const [abaSelecionada, setAbaSelecionada] = useState("");
  const [arquivo, setArquivo] = useState();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const { crud, setTitle } = useProvider();
  const { post, loading } = crud || {};

  const opcoesTituloColuna = [
    "Nome",
    "Telefone",
    "Valor Aberto",
    "Pagamento",
    "1ª Compra",
    "Última Compra",
    "Aniversário"
  ];
  const opcoesTituloColunaId = [
    "nome",
    "telefone",
    "valor_aberto",
    "data_pagamento",
    "primeira_compra",
    "ultima_compra",
    "aniversario"
  ];

  // NOVO — mapeamento coluna → título escolhido
  const [mapColunas, setMapColunas] = useState({});

  useEffect(() => setTitle("Importar Clientes"), []);

  const uploadExcel = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);

      const response = await post(
        formData,
        `/core/backup/extrair-dados-excel/`,
        "multipart/form-data"
      );

      if (response?.length) {
        const data = response[0].abas || {};
        const normalizado = {};

        Object.keys(data).forEach((aba) => {
          const linhas = Array.isArray(data[aba]) ? data[aba] : [];
          normalizado[aba] = linhas;
        });

        setAbas(normalizado);
        setAbaSelecionada(Object.keys(normalizado)[0] || "");
      }
    } catch (error) {
      if (error.response?.data) {
        setFormErrors(error.response.data);
      } else {
        setFormErrors({ apiError: "Erro ao carregar arquivo" });
      }
    }
  };

  const addLinha = (nomeAba) => {
    const colunas = abas[nomeAba].length
      ? Object.keys(abas[nomeAba][0])
      : ["Nova Coluna"];

    const novaLinha = {};
    colunas.forEach((c) => (novaLinha[c] = ""));

    setAbas({
      ...abas,
      [nomeAba]: [...abas[nomeAba], novaLinha],
    });
  };

  const removeLinha = (nomeAba, index) => {
    const lista = [...abas[nomeAba]];
    lista.splice(index, 1);
    setAbas({ ...abas, [nomeAba]: lista });
  };

  const updateCell = (nomeAba, rowIndex, coluna, valor) => {
    const temp = [...abas[nomeAba]];
    temp[rowIndex][coluna] = valor;
    setAbas({ ...abas, [nomeAba]: temp });
  };

  const addColuna = (nomeAba) => {
    const nome = prompt("Nome da nova coluna:");
    if (!nome) return;

    const linhas = abas[nomeAba].map((l) => ({ ...l, [nome]: "" }));
    setAbas({ ...abas, [nomeAba]: linhas });
  };

  const removeColuna = (nomeAba, coluna) => {
    if (!window.confirm("Remover coluna?")) return;

    const linhas = abas[nomeAba].map((l) => {
      const novo = { ...l };
      delete novo[coluna];
      return novo;
    });

    setAbas({ ...abas, [nomeAba]: linhas });

    // remove também do mapeamento
    const novoMap = { ...mapColunas };
    delete novoMap[coluna];
    setMapColunas(novoMap);
  };

  const removeAba = (nomeAba) => {
    if (!window.confirm(`Remover aba "${nomeAba}"?`)) return;

    const novo = { ...abas };
    delete novo[nomeAba];
    setAbas(novo);

    const restantes = Object.keys(novo);
    setAbaSelecionada(restantes[0] || "");
  };

  // NOVO — monta payload final da aba selecionada
  const montarPayload = () => {
    const nomeAba = abaSelecionada;
    const linhas = abas[nomeAba] || [];

    const colunasValidas = Object.keys(mapColunas).filter(
      (col) => mapColunas[col] && mapColunas[col] !== ""
    );

    const registros = linhas.map((linha) => {
      const item = {};
      colunasValidas.forEach((col) => {
        const titulo = mapColunas[col];
        const index = opcoesTituloColuna.indexOf(titulo);
        const index_name = opcoesTituloColunaId[index]
        item[index_name] = linha[col] ?? "";
      });
      return item;
    });

    return {
      aba: nomeAba,
      clientes: registros,
    };
  };
  
  const formatLocalDate = (value) => {
    if (!value) return null;
    const d = new Date(value);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      {!arquivo && (<ImportarClientes />)}
      <Card className="p-3 mt-4">
        <Form onSubmit={uploadExcel}>
          <div className="text-center">
            <Form.Group controlId="arquivoExcel" className="mb-2">
              <Form.Control
                type="file"
                accept=".xls,.xlsx"
                disabled={loading}
                onChange={(e) => setArquivo(e.target.files[0])}
              />
              {formErrors.arquivo && (
                <Alert variant="danger" className="small p-1 m-0">
                  *{formErrors.arquivo}
                </Alert>
              )}
            </Form.Group>

            <Button
              variant="outline-dark"
              className="mt-3"
              disabled={!arquivo || loading}
              type="submit"
            >
              Importar de arquivo Excel
            </Button>
          </div>
        </Form>
      </Card>

      {Object.keys(abas).length > 0 && (
        <Form.Select
          className="mt-4"
          value={abaSelecionada}
          onChange={(e) => setAbaSelecionada(e.target.value)}
        >
          <option value="">Selecione uma aba</option>
          {Object.keys(abas).map((nome) => (
            <option key={nome} value={nome}>
              {nome}
            </option>
          ))}
        </Form.Select>
      )}

      {abaSelecionada &&
        (() => {
          const nomeAba = abaSelecionada;
          const linhas = Array.isArray(abas[nomeAba]) ? abas[nomeAba] : [];
          const colunas = linhas.length ? Object.keys(linhas[0]) : [];

          return (
            <Card className="p-3 mt-4">
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0">{nomeAba}</h6>
                <div>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeAba(nomeAba)}
                  >
                    Remover Aba
                  </Button>

                  <Button
                    size="sm"
                    variant="outline-dark"
                    onClick={() => addColuna(nomeAba)}
                  >
                    + Coluna
                  </Button>
                </div>
              </div>
              *Colunas obrigatórias
              <div className="text-danger small">
                <div><b>Nome: </b>Nome do cliente</div>
                <div><b>Valor Aberto: </b>Total que o cliente deve</div>
              </div>
              <div className="table-responsive mt-3">
                <Table bordered hover size="sm" style={{ tableLayout: "fixed" }}>
                  <colgroup>
                    {colunas.map((col, i) => (
                      <col key={i} style={{ width: "220px" }} />
                    ))}
                    <col style={{ width: "60px" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      {colunas.map((col, i) => (
                        <th key={i}>
                          <div className="d-flex justify-content-between align-items-center gap-2">
                            <Form.Select
                              className="w-100"
                              value={mapColunas[col] || ""}
                              onChange={(e) =>
                                setMapColunas({
                                  ...mapColunas,
                                  [col]: e.target.value
                                })
                              }
                            >
                              <option value=""></option>
                              {opcoesTituloColuna.map((titulo) => (
                                <option key={titulo} value={titulo}>
                                  {titulo}
                                </option>
                              ))}
                            </Form.Select>

                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => removeColuna(nomeAba, col)}
                            >
                              x
                            </Button>
                          </div>
                        </th>
                      ))}
                      <th>Ação</th>
                    </tr>
                  </thead>

                  <tbody>
                    {linhas.map((linha, rowIndex) => (
                      <tr key={rowIndex}>
                        {colunas.map((col) => (
                          <td key={col}>
                            <Form.Control
                              value={linha[col] || ""}
                              onChange={(e) =>
                                updateCell(
                                  nomeAba,
                                  rowIndex,
                                  col,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        ))}

                        <td className="text-center">
                          <Button
                            size="sm"
                            variant="danger"
                            onClick={() => removeLinha(nomeAba, rowIndex)}
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="text-center">
                <Button
                  size="sm"
                  variant="outline-dark"
                  onClick={() => addLinha(nomeAba)}
                >
                  + Linha
                </Button>

                {/* NOVO — botão de enviar */}
                <Button
                  className="ms-2 px-4"
                  variant="outline-dark"
                  onClick={async () => {
                    const payload = montarPayload();
                    const lista = payload.clientes.map(c => ({
                      ...c,
                      data_pagamento: formatLocalDate(c.data_pagamento),
                      primeira_compra: formatLocalDate(c.primeira_compra),
                      ultima_compra: formatLocalDate(c.ultima_compra),
                      aniversario: formatLocalDate(c.aniversario),
                    }));

                    try {
                      await post({clientes:lista}, "/gvendas/clientes/importar-clientes/");
                      //alert("Enviado com sucesso!");
                      navigate(-1);
                    } catch (e) {
                      alert(JSON.stringify(e.response?.data?.clientes || e.response?.data || e.response));
                    }
                  }}
                >
                  Enviar
                </Button>
              </div>
            </Card>
          );
        })()}
    </>
  );
};


export default ImportFile